<template>
  <div id="print1">
    <div class="container">
      <pre> {{ updateData }}</pre>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Type</span>
            <vs-row class="mt-3 selectVS">
              <input
                class="mr-1"
                type="radio"
                id="one"
                value="false"
                v-model="updateData.type"
              />
              <label class="mr-4" for="one">Unplanned</label>
              <input
                class="mr-1"
                type="radio"
                id="two"
                value="true"
                v-model="updateData.type"
              />
              <label for="two">Planned</label></vs-row
            >
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Status</span>
            <vs-input
              disabled="true"
              class="selectVS mt-1"
              v-model="updateData.iscomplete"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">WO Name</span>
            <vs-input
              class="selectVS mt-1"
              placeholder="Placeholder"
              v-model="updateData.name"
            />
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Priority</span>
            <vs-select class="selectVS mt-1" v-model="updateData.priority">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in optionsPriority"
              />
            </vs-select>
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">#</span>
            <vs-input
              disabled="true"
              class="selectVS mt-1"
              placeholder="Placeholder"
              v-model="updateData.id"
            />
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Asset</span>
            <vs-input
              class="selectVS mt-1"
              placeholder="Placeholder"
              v-model="updateData.asset"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Assignee</span>
            <vs-select
              class="selectVS mt-1"
              @change="onChange(updateData.username)"
              v-model="updateData.username"
            >
              <vs-select-item
                :key="index"
                :value="item.name"
                :text="item.name"
                v-for="(item, index) in workerlist"
              />
            </vs-select>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">E-mail</span>
            <vs-input
              disabled="true"
              class="selectVS mt-1"
              placeholder="Placeholder"
              v-model="updateData.email"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Start Date</span>
            <div class="selectVS mt-1">
              <VueCtkDateTimePicker
                position="bottom"
                style="heigth: 15px"
                format="YYYY-MM-DD HH:mm:ss"
                v-model="updateData.plandate"
              ></VueCtkDateTimePicker>
            </div>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Actual Start Date</span>
            <vs-input
              disabled="true"
              class="selectVS mt-1"
              placeholder="Placeholder"
              v-model="updateData.startdate"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Due Date</span>
            <div class="selectVS mt-1">
              <VueCtkDateTimePicker
                position="bottom"
                format="YYYY-MM-DD HH:mm:ss"
                v-model="updateData.duedate"
              ></VueCtkDateTimePicker>
            </div>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="6">
          <div class="input-box container-fluid">
            <span class="detail">Actual End Date</span>
            <vs-input
              disabled="true"
              class="selectVS mt-1"
              placeholder="Placeholder"
              v-model="updateData.finishtime"
            />
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-align="center" vs-w="12">
          <div class="input-box container-fluid">
            <span class="detail">Instructions</span><br />
            <vs-textarea class="widthTextArea" v-model="updateData.detail" />
          </div>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { FormRenderer } from "v-form-builder";
import { VueEditor } from "vue2-editor";
export default {
  name: "",
  components: {
    VueEditor,
    FormRenderer,
  },
  props: {
    viewwork: Array,
    dataPrint: Array,
    updateData: Array,
    workerlist: Array,
  },
  data: () => ({
    users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        email: "Shanna@melissa.tv",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        email: "Nathan@yesenia.net",
        website: "ramiro.info",
      },
    ],
    role: "",
    compleNote: "",
    dataPrint: [],
    dataViewwork: [],
    nameValue: "",
    viewpercentage: 0,
    formData: "",
    activePrompt: false,
    optionEdit: false,
    content: "",
    select1: 2,
    select2: 7,
    idWO: "",
    dataa: [],
    optionsPriority: [
      { text: "1 - Low Priority", value: "1 - Low priority" },
      { text: "2 - Medium Priority", value: "2 - Medium priority" },
      { text: "3 - High Priority", value: "3 - High priority" },
    ],
  }),
  methods: {
    saveEdit() {
      console.log(this.updateData);
      this.$http
        .post(this.$url2 + "editwork", {
          data: this.updateData,
        })
        .then(() => {
          // location.reload();
        });
    },
    onChange(item) {
      console.log(item);
      this.workerlist.forEach((value) => {
        if (this.updateData.username == value.name) {
          console.log(value.email);
          this.updateData.email = value.email;
        }
      });
    },
    setArray() {
      this.viewwork = [];
    },
    printmodal() {
      const modal = document.getElementById("print1");
      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
      return false;
      // this.viewwork = [];
    },
    cancel() {
      location.reload();
    },
    complete2() {
      // console.log(this.viewwork.id);
      const body = {
        id: this.viewwork.id,
        username: this.viewwork.username,
        status: "true",
      };
      this.$API
        .post("updateworkstatus", body)
        .then((result) => {
          if (result.status == 200)
            this.$vs.notify({
              title: "Work Order Updated",
              text: "Your work order has been updated",
              color: "primary",
              position: "top-center",
            });
          setTimeout(() => {
            location.reload(1);
          }, 1000);
        })
        .catch((err) => {
          if (err.response.status == 500)
            this.$vs.notify({
              title: "Invalid",
              text: "Please try again",
              color: "warning",
              position: "top-center",
            });
        });
      console.log(body);
    },
  },
  mounted() {
    this.role = this.$session.get("role");
    // this.viewwork = this.$session.get("viewwork");
    this.dataPrint = this.$session.get("dataPrint");
    console.log("mounting table");
    this.viewpercentage = 0;
    var maxitem = 0;
    var nullitem = 0;
    var item = this.viewwork;
    console.log(item);
    this.formData = item.form;
    this.activePrompt = true;
    setTimeout(() => {
      this.formInputData = item.inputdata;
      console.log(this.formInputData);
      if (item.inputdata) {
        Object.keys(item.inputdata).forEach((element) => {
          maxitem += 1;
          if (
            item.inputdata[element] == null ||
            item.inputdata[element] == 0 ||
            item.inputdata[element] == ""
          ) {
            nullitem += 1;
          }
        });
        this.viewpercentage = ([(maxitem - nullitem) / maxitem] * 100).toFixed(
          2
        );
      }
    }, 200);
  },
  beforeDestroy() {
    this.viewwork = [];
  },
};
</script>


<style scoped>
.brdbtn {
  width: 80px;
  border-radius: 20px;
}
/* *{
  margin:0;
  padding:0;
  box-sizing: border-box;
}
body{ 
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items:center;
  padding: 10px;
}
.container{
  max-width: 700px;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
}
.container form .user-detail{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
form .user-detail .vs-select .vs-input{
  margin: 20px 0 12px 0;
  width: calc(100% / 2 - 10%);
}
.user-detail .vs-input .vs-select {
  height: 200px;
  width: 100%;
}
.user-detail .vs-select .vs-input .details {
  font-weight: 500px;
  margin-bottom: 5px;
}
.selectVS{
  width: 250px;
} */
.notiApproval {
  background: #e3fadd;
  border-color: #8bed84;
}
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  padding: 0;
}
.selectVS {
  width: 75%;
  font-size: 0.75rem;
  white-space: nowrap;
}
.widthTextArea {
  width: 100%;
}
.textAreaBox {
  display: block;
  width: 99%;
  font-size: 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.8);
  padding: 9px;
  overflow: hidden;
  min-height: 40px;
  line-height: 20px;
}
.textAreaComment {
  display: block;
  width: 100%;
  font-size: 0.75rem;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.8);
  padding: 9px;
  overflow: hidden;
  min-height: 40px;
  line-height: 20px;
}
.detail {
  font-size: 0.75rem;
  font-weight: 100;
}
.inputData {
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
#btnShare {
  color: #111111;
  border-radius: 20px;
  display: inline-block;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
#center {
  text-align: center;
}
#allIcon {
  font-size: 16px;
}
.modal-open .modal {
  padding-right: 0px;
}
.p-0 {
  padding: 0;
}
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}

#editor1 {
  height: 350px;
  width: 900px;
}

.inputdes {
  width: 300px;
}
.c {
  width: 300px;
  border-radius: 100px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
@media screen and (max-width: 992px) {
  /* .container {
    background-color: yellowgreen;
  } */
  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    padding: 0;
  }
  form .user-detail .vs-select .vs-input {
    width: calc(100% / 2 - 20px);
  }
  .selectVS {
    width: 200px;
  }
  .textAreaBox {
    width: 98%;
  }
}
.a {
  /* background-color: beige; */
}
.b {
  /* background-color: cadetblue; */
  padding-left: 0;
}
.d {
  background-color: grey;
}
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#v {
  display: none;
}
#center {
  display: flex;
  align-items: center;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
@media screen and (max-width: 600px) {
  /* .container {
    background-color: yellowgreen;
  } */
  .container,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    padding: 0;
  }
  form .user-detail .vs-select .vs-input {
    width: calc(100% / 2 - 20px);
  }
  .selectVS {
    width: 200px;
  }
  /* .textAreaBox {
    width: 100%;
  } */
}
</style>
